module.exports = __webpack_public_path__ + "static/img/yytx24.4148825.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/yytx24.png
// module id = 893
// module chunks = 0